import { getStoredAccessToken } from '@/modules/auth/helpers/TokenStorage'

export default function setupAxios(axios: any, store: any) {
  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: {accessToken, selectedCompany},
      } = store.getState()

      const fallbackToken = getStoredAccessToken()
      const effectiveToken = accessToken || fallbackToken

      const storedCompanyRaw = localStorage.getItem('selected_company') || sessionStorage.getItem('selected_company')
      let storedCompany: any = null
      try {
        storedCompany = storedCompanyRaw ? JSON.parse(storedCompanyRaw) : null
      } catch (e) {
        storedCompany = null
      }
      const effectiveSelectedCompany = selectedCompany || storedCompany

      // console.log('🚀 Axios request:', {
      //   url: config.url,
      //   method: config.method,
      //   data: JSON.stringify(config.data),
      //   headers: JSON.stringify(config.headers),
      //   hasAccessToken: !!accessToken
      // });

      // List of public endpoints that don't require authentication
      const publicEndpoints = [
        '/api/addresses/provinces/',
        '/api/addresses/provinces/',
        '/api/addresses/wards/',
        '/api/addresses/test/',
      ]

      // Check if the current URL is a public endpoint
      const isPublicEndpoint = publicEndpoints.some(endpoint => 
        config.url?.includes(endpoint)
      )

      // Only add Authorization header if we have a token and it's not a public endpoint
      if (effectiveToken && !isPublicEndpoint) {
        config.headers.Authorization = `Bearer ${effectiveToken}`
      }

      const isCompaniesListEndpoint =
        config.method?.toLowerCase() === 'get' &&
        (config.url === '/companies/' || config.url?.startsWith('/companies/?'))

      if (!isCompaniesListEndpoint) {
        // Header requirements:
        // - Prefer auth.selectedCompany/localStorage selected_company
        // - Fallback: if request body/query carries `company` / `company_id`, use that.
        const rawCompanyIdFromStore = effectiveSelectedCompany?.company_id;
        const rawCompanyIdFromRequest =
          config?.data?.company_id ||
          config?.data?.company ||
          config?.params?.company_id ||
          config?.params?.company;

        const rawCompanyId = rawCompanyIdFromStore || rawCompanyIdFromRequest;

        const shouldSetHeader =
          rawCompanyId &&
          typeof rawCompanyId === 'string' &&
          rawCompanyId.trim() &&
          rawCompanyId !== 'global' &&
          rawCompanyId !== 'all';

        if (shouldSetHeader) {
          config.headers = config.headers || {};

          // Don't override an explicitly set header.
          if (!config.headers['X-Selected-Company']) {
            const normalizedRawCompanyId = String(rawCompanyId).trim();

            // Normalize selectedCompany id: some flows store company_code in company_id
            // (e.g. 'c-wood'). Prefer the canonical UUID from auth.companies when available.
            try {
              const companies = store.getState()?.auth?.companies || [];
              const normalized = companies.find(
                (c: any) => c.company_id === normalizedRawCompanyId || c.company_code === normalizedRawCompanyId,
              );
              const headerCompanyId = normalized ? normalized.company_id : normalizedRawCompanyId;
              config.headers['X-Selected-Company'] = headerCompanyId;
            } catch (err) {
              config.headers['X-Selected-Company'] = normalizedRawCompanyId;
            }
          }
        }
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )

  // Response interceptor to handle 401 errors
  axios.interceptors.response.use(
    (response: any) => {
      // console.log('✅ Axios response:', {
      //   url: response.config?.url,
      //   status: response.status,
      //   data: response.data
      // });
      return response
    },
    (error: any) => {
      // console.log('❌ Axios error:', {
      //   url: error.config?.url,
      //   status: error.response?.status,
      //   data: JSON.stringify(error.response?.data),
      //   message: error.message
      // });
      
      if (error.response?.status === 401) {
        // Don't logout for login endpoint (401 is expected for wrong credentials)
        const isLoginEndpoint = error.config?.url?.includes('/accounts/login/')
        const isProfileEndpoint = error.config?.url?.includes('/accounts/profile/')
        
        // Don't auto-logout for profile endpoint - let AuthInit handle it
        if (!isLoginEndpoint && !isProfileEndpoint) {
          // Clear auth state
          store.dispatch({ type: '[Logout] Action' })
          
          // Redirect to login page with basename
          const { getPathWithBasename } = require('@/__core/helpers/getBasename');
          window.location.href = getPathWithBasename('/auth/login')
        }
      }
      return Promise.reject(error)
    }
  )
}
